import type {CreateExtArgs} from '@wix/document-manager-core'
import _ from 'lodash'
import {getAccessibilitySettings, setAccessibilitySettings} from './utils'

interface VisualFocusAPI {
    get(): boolean
    set(enabled: boolean): void
}

export const createVisualFocusAPI = (createExtArgs: CreateExtArgs): VisualFocusAPI => {
    const get = (): boolean => {
        const settings = getAccessibilitySettings(createExtArgs)
        const vfFlag = _.get(settings, ['visualFocusDisabled'])
        return _.isUndefined(vfFlag) ? false : !vfFlag
    }

    const set = (enabled: boolean): void => {
        if (!_.isBoolean(enabled)) {
            throw new Error('visualFocus.set accepts only boolean value')
        }

        setAccessibilitySettings(createExtArgs, {
            visualFocusDisabled: !enabled
        })
    }

    return {
        get,
        set
    }
}
